import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  width: 24px;
  height: 24px;
  path {
    fill: currentColor;
    transition: fill 0.2s ease;
  }
`;

export const DsChevronRightArrowIcon: React.FC = () => (
  <Svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.816 7.456L8.832 8.456L12.816 12L8.832 15.544L9.856 16.544L15.184 12L9.816 7.456Z" />
  </Svg>
);

export const DsChevronLeftArrowIcon: React.FC = () => (
  <Svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scaleX(-1)' }}>
    <path d="M9.816 7.456L8.832 8.456L12.816 12L8.832 15.544L9.856 16.544L15.184 12L9.816 7.456Z" />
  </Svg>
);
